// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['gl_ES']  = {
  "name": "gl_ES",
  "day": {
    "abbrev": [
      "Dom",
      "Lun",
      "Mar",
      "Mér",
      "Xov",
      "Ven",
      "Sáb"
    ],
    "full": [
      "Domingo",
      "Luns",
      "Martes",
      "Mércores",
      "Xoves",
      "Venres",
      "Sábado"
    ]
  },
  "month": {
    "abbrev": [
      "Xan",
      "Feb",
      "Mar",
      "Abr",
      "Mai",
      "Xuñ",
      "Xul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dec"
    ],
    "full": [
      "Xaneiro",
      "Febreiro",
      "Marzo",
      "Abril",
      "Maio",
      "Xuño",
      "Xullo",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Decembro"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d/%m/%y",
  "time24": "%T",
  "dateTime": "%a %d %b %Y %T %Z",
  "time12": "",
  "full": "%a %b %e %H:%M:%S %Z %Y"
}

